import script from "./JourneyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JourneyPage.vue?vue&type=script&setup=true&lang=js"

import "./JourneyPage.vue?vue&type=style&index=0&id=4ac58064&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac58064"]])

export default __exports__